module.exports = "/_next/static/images/b55845182ea2e3fff2aae63301db8d5a-phone-with-app-open-and-card@1x-md.jpg";